import NavBarWrapper from "@Components/NavigationBar/NavBarWrapper";
import NavigationBar from "@Components/NavigationBar/NavigationBar";
import FallbackPage from "@Pages/FallBackPage/FallBackPage";
import Login from "@Pages/Login/Login";
import { useSelector } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import * as DefaultRoutes from "@Routes/DefaultRoutes";
import SideBar from "@Components/SideBar/SideBarComponent";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import VerificationCode from "@Pages/VerificationCode/VerificationCode";
import EmailVerifyScreen from "@Pages/EmailVerifyScreen/EmailVerifyScreen";
import ChangePasswordScreen from "@Pages/ChangePasswordScreen/ChangePasswordScreen";
import AdminHome from "@Pages/Admin/AdminHomePage/AdminHomePage";
import MaterialsListing from "@Pages/Admin/Materials/MaterialsListing";
import WarhousesListing from "@Pages/Admin/Warehouses/WarhousesListing";
import SuppliersListing from "@Pages/Admin/Suppliers/SuppliersListing";
import StorageLocationsListing from "@Pages/Admin/StorageLocations/StorageLocationsListing";
import ClearanceAgentsListing from "@Pages/Admin/ClearanceAgents/ClearanceAgentsListing";
import VendorsListing from "@Pages/Admin/Vendors/VendorsListing";
import CategoriesListing from "@Pages/Admin/Categories/CategoriesListing";
import BanksListing from "@Pages/Admin/Banks/BanksListing";
import ShippingLinesListing from "@Pages/Admin/ShippingLines/ShippingLinesListing";
import UsersListing from "@Pages/Admin/Users/UsersListing";
import PlannersListing from "@Pages/Admin/Planners/PlannersListing";
import Profile from "@Pages/Profile/ProfilePage";
import RolesHomePage from "../Pages/RolesHomePage/RolesHomePage";
import PendingOrdersListing from "@Pages/ClearanceCoordinator/Orders/ClearancePendingOrdersListing";
import AddNewOrders from "../Pages/ClearanceCoordinator/AddOrderForm/AddNewOrder";
import Notification from "../Pages/Notification/Notification";
import ReleaseOrdersListing from "../Pages/OrderListing/ReleaseOrdersListing";
import FullOrderInfo from "../Pages/ClearanceCoordinator/Orders/ClearanceCoordinatorFullOrderInfo";
import CanceledOrdersListing from "../Pages/OrderListing/CanceledOrdersListing";
import OrderInvoice from "../Pages/Invoices/OrderInvoice";
import AgentPortfolio from "../Pages/Admin/Agent Portfolio/AgentPortfolio";
import VendorPortfolio from "../Pages/Admin/Vendor Portfolio/VendorPortfolio";
import AddApproval from "../Pages/Approvals/AddApproval";
import AddCargoX from "../Pages/CargoX/AddCargoX";
import ClearanceAgentPendingOrdersListing from "../Pages/ClearanceAgent/ClearanceAgentPendingOrdersListing";
import ClearanceAgentOrderInfoPage from "../Pages/ClearanceAgent/ClearanceAgentFullOrderInfo";
import ClearanceManagerPendingOrdersListing from "../Pages/ClearanceManager/ClearanceManagerPendingOrders";
import ClearanceManagerOrderInfoPage from "../Pages/ClearanceManager/ClearanceManagerFullOrderInfo";
import FinancialCoordinatorPendingOrdersListing from "../Pages/FinancialCoordinator/FinancialCoordinatorPendingOrdersListing";
import FinancialCoordinatorOrderInfoPage from "../Pages/FinancialCoordinator/FinancialCoordinatorFullOrderInfo";
import SyasatOrderInfoPage from "../Pages/Syasat/SyasatOrderInfoPage/SyasatFullOrderInfo";
import SyasatPendingOrderListing from "../Pages/Syasat/SyasatPendingOrdersListing/SyasatPendingOrderListing";
import PlannerPendingOrderListing from "../Pages/Planner/PlannerPendingOrdersListing/PlannerPendingOrderListing";
import PlannerOrderInfoPage from "../Pages/Planner/PlannerOrderInfoPage/PlannerFullOrderInfo";
import QualityOrderInfoPage from "../Pages/QualityMebmer/QualityOrderInfoPage/QualityOrderInfoPage";
import WareHouseOrderInfoPage from "../Pages/WareHouseMember/WareHouseOrderInfoPage/WareHouseOrderInfoPage";
import Form4PendingOrdersListing from "../Pages/Form4Coordinator/Form4PendingOrderslisting/Form4PendingOrdersListing";
import Form4OrderInfoPage from "../Pages/Form4Coordinator/Form4FullOrdersListingInfo/Form4FullOrderInfo";
import ClearanceDashboard from "../Pages/Dashboards/ClearanceDashboard";
import PlanningManagerPendingOrdersListing from "../Pages/PlanningManager/PlanningManagerPendingOrders/PlanningManagerPendingOrders";
import PlanningManagerOrderInfoPage from "../Pages/PlanningManager/PlanningManagerFullOrderInfo/PlanningManagerFullOrderInfo";
import ClearanceCoordinatorHomePage from "../Pages/ClearanceCoordinator/ClearanceCoordinatorHomePage/ClearanceCoordinatorHomePage";
import AllPendingOrdersListing from "../Pages/OrderListing/AllPendingOrderListing";
import GroupedOrdersListing from "../Pages/OrderListing/GroupedOrdersListing";
import AllReleasedOrdersListing from "../Pages/OrderListing/AllReleasedOrderListing";
import PaymentDashboard from "../Pages/Dashboards/PaymentDashboard";
import ClearanceManagerHomePage from "../Pages/ClearanceManager/ClearanceManagerHomePage";
import ChatPopup from "@Pages/ChatBot/ChatPopup";
import PaymentsListing from "../Pages/PaymentsListing/PaymentsListing";
import PaymentPreview from "../Pages/PaymentsListing/PaymentPreview";
import ClearanceStarredOrdersListing from "../Pages/ClearanceCoordinator/Orders/ClearanceStarredOrdersListing";
import ClearanceManagerStarredOrdersListing from "../Pages/ClearanceManager/ClearanceManagerStarredOrdersListing";
import FinancialCoordinatorStarredOrdersListing from "../Pages/FinancialCoordinator/FinancialCoordinatorStarredOrdersListing";
import Form4StarredOrdersListing from "../Pages/Form4Coordinator/Form4StarredOrdersListing/Form4StarredOrdersListing";
import PlannerStarredOrderListing from "../Pages/Planner/PlannerStarredOrdersListing/PlannerStarredOrdersListing";
import PlanningManagerStarredOrdersListing from "../Pages/PlanningManager/PlannerManagerStarredOrderListing/PlannerManagerStarredOrderListing";
import SyasatStarredOrderListing from "../Pages/Syasat/SyasatStarredOrderListing/SyasatStarredOrderListing";
import ClearanceAgentStarredOrdersListing from "../Pages/ClearanceAgent/ClearanceAgentStarredOrdersListing";
import NotReadOnlyMSDSFilesListing from "../Pages/MSDSFiles/NotReadOnlyMSDSFilesListing";
import ReadOnlyMSDSFilesListing from "../Pages/MSDSFiles/ReadOnlyMSDSFilesListing";
import BulkInsert from "../Pages/Admin/BulkInsert/BulkInsert";
import TransportationCoordinatorHomePage from "../Pages/TransportationCoordinator/TransportationCoordinatorHomePage/TransportationCoordinatorHomePage";
import TransportationCoordinatorPendingOrder from "../Pages/TransportationCoordinator/TransportationCoordinatorPendingOrder/TransportationCoordinatorPendingOrder";
import TransportationCoordinatorReleasedOrder from "../Pages/TransportationCoordinator/TransportationCoordinatorReleasedOrder/TransportationCoordinatorReleasedOrder";
import TransportationCoordinatorFullOrderInfo from "../Pages/TransportationCoordinator/TransportationCoordinatorFullOrderInfo/TransportationCoordinatorFullOrderInfo";
import PlannerHomePage from "../Pages/Planner/PlannerHomePage/PlannerHomePage";
import QualityHomePage from "../Pages/QualityMebmer/QualityHomePage/QualityHomePage";
import WareHouseHomePage from "../Pages/WareHouseMember/WareHouseHomePage/WareHouseHomePage";
import RouteTransitionHandler from "./RouteTransitionHandler";
import TreasuryCoordinatorHomePage from "../Pages/TreasuryCoordinator/TreasuryCoordinatorHomePage";
import TreasuryCoordinatorPendingOrder from "../Pages/TreasuryCoordinator/TreasuryCoordinatorPendingOrders";
import TreasuryCoordinatorReleasedOrder from "../Pages/TreasuryCoordinator/TreasuryCoordinatorReleaseOrder";
import TreasuryCoordinatorFullOrderInfo from "../Pages/TreasuryCoordinator/TreasuryCoordinatorFullOrderInfo";
import TreasuryCoordinatorOrderListing from "../Pages/TreasuryCoordinator/TreasuryCoordinatorOrderListing";
import TreasuryCoordinatorTransactionDetails from "../Pages/TreasuryCoordinator/TreasuryCoordinatorTransactionDetails";
import TreasuryCoordinatorStarOrdersListing from "../Pages/TreasuryCoordinator/TreasuryCoordinatorStarOrders";
import ClearnaceCoordinatorTransactionListing from "../Pages/ClearanceCoordinator/Orders/ClearanceCoorindatorTransactionListing";
import ClearnaceCoordinatorTransactionDetails from "../Pages/ClearanceCoordinator/Orders/ClearanceCoordinatorTransactionDetails";

export default function Paths() {
  const user = useSelector((state) => state.user);
  const theme = useTheme();
  return (
    <Router>
      <>
        <RouteTransitionHandler />
        {/* Chat Popup for all users except ADMIN */}
        {user.isLogged && !user.roles?.includes("ADMIN") && <ChatPopup />}

        <Routes>
          {!user.isLogged && (
            <>
              <Route path="/" element={<Login />} />
              <Route path={DefaultRoutes.home} element={<Login />} />
              <Route path={DefaultRoutes.fallback} element={<FallbackPage />} />
              <Route
                path={DefaultRoutes.verificationCode}
                element={<VerificationCode />}
              />
              <Route
                path={DefaultRoutes.emailVerification}
                element={<EmailVerifyScreen />}
              />
              <Route
                path={DefaultRoutes.changePassword}
                element={<ChangePasswordScreen />}
              />
            </>
          )}
          {user.isLogged &&
            user.roles?.includes("EXTERNAL_TREASURY_COORDINATOR") && (
              <Route
                path="*"
                element={
                  <>
                    <NavBarWrapper user={user}>
                      <NavigationBar text="Clearance" user={user} />
                    </NavBarWrapper>
                    {user.isLogged && <SideBar />}
                    <Box
                      sx={{
                        pt: `${theme.navbar.navbarHeight}px`,
                        ml: `${theme.sidebar.sidebarWidth}px`,
                      }}
                    >
                      <Routes>
                        <Route
                          path="/"
                          element={<TreasuryCoordinatorHomePage />}
                        />
                        <Route
                          path={DefaultRoutes.profile}
                          element={<Profile />}
                        />
                        <Route
                          path={DefaultRoutes.home}
                          element={<TreasuryCoordinatorHomePage />}
                        />
                        <Route
                          path={DefaultRoutes.allPendingOrders}
                          element={<TreasuryCoordinatorPendingOrder />}
                        />
                        <Route
                          path={DefaultRoutes.groupView}
                          element={<GroupedOrdersListing />}
                        />
                        <Route
                          path={DefaultRoutes.transactionOrderListing}
                          element={<ClearnaceCoordinatorTransactionListing />}
                        />
                        <Route
                          path={DefaultRoutes.transactionDetails}
                          element={<ClearnaceCoordinatorTransactionDetails />}
                        />
                        <Route
                          path={DefaultRoutes.transactionGroupDetails}
                          element={<ClearnaceCoordinatorTransactionDetails />}
                        />
                        <Route
                          path={DefaultRoutes.allReleasedOrders}
                          element={<TreasuryCoordinatorReleasedOrder />}
                        />
                        <Route
                          path={DefaultRoutes.orderInfo}
                          element={<TreasuryCoordinatorFullOrderInfo />}
                        />
                        <Route
                          path={DefaultRoutes.notifications}
                          element={<Notification />}
                        />
                        <Route
                          path={DefaultRoutes.starredOrders}
                          element={<TreasuryCoordinatorStarOrdersListing />}
                        />
                        <Route
                          path={DefaultRoutes.error}
                          element={<FallbackPage isErrorPage={true} />}
                        />
                      </Routes>
                    </Box>
                  </>
                }
              />
            )}
          {user.isLogged && user.roles?.includes("TREASURY_COORDINATOR") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="Clearance" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route
                        path="/"
                        element={<TreasuryCoordinatorHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.home}
                        element={<TreasuryCoordinatorHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.allPendingOrders}
                        element={<TreasuryCoordinatorPendingOrder />}
                      />
                      <Route
                        path={DefaultRoutes.groupView}
                        element={<GroupedOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.transactionOrderListing}
                        element={<TreasuryCoordinatorOrderListing />}
                      />
                      <Route
                        path={DefaultRoutes.transactionDetails}
                        element={<TreasuryCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.transactionGroupDetails}
                        element={<TreasuryCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.allReleasedOrders}
                        element={<TreasuryCoordinatorReleasedOrder />}
                      />
                      <Route
                        path={DefaultRoutes.orderInfo}
                        element={<TreasuryCoordinatorFullOrderInfo />}
                      />
                      <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                      />
                      <Route
                        path={DefaultRoutes.starredOrders}
                        element={<TreasuryCoordinatorStarOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}
          {user.isLogged &&
            user.roles?.includes("TRANSPORTATION_COORDINATOR") && (
              <Route
                path="*"
                element={
                  <>
                    <NavBarWrapper user={user}>
                      <NavigationBar text="Clearance" user={user} />
                    </NavBarWrapper>
                    {user.isLogged && <SideBar />}
                    <Box
                      sx={{
                        pt: `${theme.navbar.navbarHeight}px`,
                        ml: `${theme.sidebar.sidebarWidth}px`,
                      }}
                    >
                      <Routes>
                        <Route
                          path="/"
                          element={<TransportationCoordinatorHomePage />}
                        />
                        <Route
                          path={DefaultRoutes.profile}
                          element={<Profile />}
                        />
                        <Route
                          path={DefaultRoutes.home}
                          element={<TransportationCoordinatorHomePage />}
                        />
                        <Route
                          path={DefaultRoutes.allPendingOrders}
                          element={<TransportationCoordinatorPendingOrder />}
                        />
                        <Route
                          path={DefaultRoutes.groupView}
                          element={<GroupedOrdersListing />}
                        />
                        <Route
                          path={DefaultRoutes.allReleasedOrders}
                          element={<TransportationCoordinatorReleasedOrder />}
                        />
                        <Route
                          path={DefaultRoutes.clearanceDashboard}
                          element={<ClearanceDashboard />}
                        />
                        <Route
                          path={DefaultRoutes.orderInfo}
                          element={<TransportationCoordinatorFullOrderInfo />}
                        />
                        <Route
                          path={DefaultRoutes.cargox}
                          element={<AddCargoX />}
                        />
                        <Route
                          path={DefaultRoutes.notifications}
                          element={<Notification />}
                        />
                        <Route
                          path={DefaultRoutes.starredOrders}
                          element={<ClearanceStarredOrdersListing />}
                        />
                        <Route
                          path={DefaultRoutes.error}
                          element={<FallbackPage isErrorPage={true} />}
                        />
                      </Routes>
                    </Box>
                  </>
                }
              />
            )}
          {user.isLogged && user.roles?.includes("CLEARANCE_COORDINATOR") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="Clearance" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route
                        path="/"
                        element={<ClearanceCoordinatorHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.home}
                        element={<ClearanceCoordinatorHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.transactionOrderListing}
                        element={<ClearnaceCoordinatorTransactionListing />}
                      />
                      <Route
                        path={DefaultRoutes.groupView}
                        element={<GroupedOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.transactionDetails}
                        element={<ClearnaceCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.transactionGroupDetails}
                        element={<ClearnaceCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.pendingOrders}
                        element={<PendingOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.payments}
                        element={<PaymentsListing />}
                      />
                      <Route
                        path={DefaultRoutes.paymentPreview}
                        element={<PaymentPreview />}
                      />
                      <Route
                        path={DefaultRoutes.allPendingOrders}
                        element={<AllPendingOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.releasedOrders}
                        element={<ReleaseOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.allReleasedOrders}
                        element={<AllReleasedOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.canceledOrders}
                        element={<CanceledOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.clearanceDashboard}
                        element={<ClearanceDashboard />}
                      />
                      <Route
                        path={DefaultRoutes.addneworders}
                        element={<AddNewOrders />}
                      />
                      <Route
                        path={DefaultRoutes.orderInfo}
                        element={<FullOrderInfo />}
                      />
                      <Route
                        path={DefaultRoutes.otherOrderInfo}
                        element={<ClearanceManagerOrderInfoPage />}
                      />
                      <Route
                        path={DefaultRoutes.invoice}
                        element={<OrderInvoice />}
                      />
                      <Route
                        path={DefaultRoutes.approval}
                        element={<AddApproval />}
                      />
                      <Route
                        path={DefaultRoutes.cargox}
                        element={<AddCargoX />}
                      />
                      <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                      />
                      <Route
                        path={DefaultRoutes.msdsdirectory}
                        element={<NotReadOnlyMSDSFilesListing />}
                      />
                      <Route
                        path={DefaultRoutes.starredOrders}
                        element={<ClearanceStarredOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}

          {user.isLogged && user.roles?.includes("CLEARANCE_AGENT") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="Clearance" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route path="/" element={<RolesHomePage />} />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.home}
                        element={<RolesHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.pendingOrders}
                        element={<ClearanceAgentPendingOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.releasedOrders}
                        element={<ReleaseOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.canceledOrders}
                        element={<CanceledOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.clearanceDashboard}
                        element={<ClearanceDashboard />}
                      />
                      <Route
                        path={DefaultRoutes.orderInfo}
                        element={<ClearanceAgentOrderInfoPage />}
                      />
                      <Route
                        path={DefaultRoutes.invoice}
                        element={<OrderInvoice />}
                      />
                      <Route
                        path={DefaultRoutes.approval}
                        element={<AddApproval />}
                      />
                      <Route
                        path={DefaultRoutes.cargox}
                        element={<AddCargoX />}
                      />
                      <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                      />
                      <Route
                        path={DefaultRoutes.starredOrders}
                        element={<ClearanceAgentStarredOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.msdsdirectory}
                        element={<NotReadOnlyMSDSFilesListing />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}

          {user.isLogged && user.roles?.includes("SYASAT") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="Syasat" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route path="/" element={<RolesHomePage />} />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.home}
                        element={<RolesHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.pendingOrders}
                        element={<SyasatPendingOrderListing />}
                      />
                      <Route
                        path={DefaultRoutes.releasedOrders}
                        element={<ReleaseOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.canceledOrders}
                        element={<CanceledOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.clearanceDashboard}
                        element={<ClearanceDashboard />}
                      />
                      <Route
                        path={DefaultRoutes.orderInfo}
                        element={<SyasatOrderInfoPage />}
                      />
                      <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                      />
                      <Route
                        path={DefaultRoutes.approval}
                        element={<AddApproval />}
                      />
                      <Route
                        path={DefaultRoutes.starredOrders}
                        element={<SyasatStarredOrderListing />}
                      />
                      <Route
                        path={DefaultRoutes.msdsdirectory}
                        element={<NotReadOnlyMSDSFilesListing />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}

          {user.isLogged && user.roles?.includes("CLEARANCE_MANAGER") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="Clearance Manager" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route path="/" element={<ClearanceManagerHomePage />} />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.home}
                        element={<ClearanceManagerHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.pendingOrders}
                        element={<ClearanceManagerPendingOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.transactionOrderListing}
                        element={<ClearnaceCoordinatorTransactionListing />}
                      />
                      <Route
                        path={DefaultRoutes.groupView}
                        element={<GroupedOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.transactionDetails}
                        element={<ClearnaceCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.transactionGroupDetails}
                        element={<ClearnaceCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.payments}
                        element={<PaymentsListing />}
                      />
                      <Route
                        path={DefaultRoutes.paymentPreview}
                        element={<PaymentPreview />}
                      />
                      <Route
                        path={DefaultRoutes.releasedOrders}
                        element={<ReleaseOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.canceledOrders}
                        element={<CanceledOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.orderInfo}
                        element={<ClearanceManagerOrderInfoPage />}
                      />
                      <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                      />
                      <Route
                        path={DefaultRoutes.clearanceDashboard}
                        element={<ClearanceDashboard />}
                      />
                      <Route
                        path={DefaultRoutes.paymentDashboard}
                        element={<PaymentDashboard />}
                      />
                      <Route
                        path={DefaultRoutes.starredOrders}
                        element={<ClearanceManagerStarredOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.msdsdirectory}
                        element={<ReadOnlyMSDSFilesListing />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}

          {user.isLogged && user.roles?.includes("PLANNING_MANAGER") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="Planning Manager" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route path="/" element={<RolesHomePage />} />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.home}
                        element={<RolesHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.transactionOrderListing}
                        element={<ClearnaceCoordinatorTransactionListing />}
                      />
                      <Route
                        path={DefaultRoutes.groupView}
                        element={<GroupedOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.transactionDetails}
                        element={<ClearnaceCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.transactionGroupDetails}
                        element={<ClearnaceCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.pendingOrders}
                        element={<PlanningManagerPendingOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.releasedOrders}
                        element={<ReleaseOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.canceledOrders}
                        element={<CanceledOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.orderInfo}
                        element={<PlanningManagerOrderInfoPage />}
                      />
                      <Route
                        path={DefaultRoutes.clearanceDashboard}
                        element={<ClearanceDashboard />}
                      />
                      <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                      />
                      <Route
                        path={DefaultRoutes.starredOrders}
                        element={<PlanningManagerStarredOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.msdsdirectory}
                        element={<ReadOnlyMSDSFilesListing />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}

          {user.isLogged && user.roles?.includes("FINANCIAL") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="Financial" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route path="/" element={<RolesHomePage />} />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.home}
                        element={<RolesHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.pendingOrders}
                        element={<FinancialCoordinatorPendingOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.transactionOrderListing}
                        element={<ClearnaceCoordinatorTransactionListing />}
                      />
                      <Route
                        path={DefaultRoutes.groupView}
                        element={<GroupedOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.transactionDetails}
                        element={<ClearnaceCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.transactionGroupDetails}
                        element={<ClearnaceCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.payments}
                        element={<PaymentsListing />}
                      />
                      <Route
                        path={DefaultRoutes.releasedOrders}
                        element={<ReleaseOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.canceledOrders}
                        element={<CanceledOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.clearanceDashboard}
                        element={<ClearanceDashboard />}
                      />
                      <Route
                        path={DefaultRoutes.orderInfo}
                        element={<FinancialCoordinatorOrderInfoPage />}
                      />
                      <Route
                        path={DefaultRoutes.paymentPreview}
                        element={<PaymentPreview />}
                      />
                      <Route
                        path={DefaultRoutes.invoice}
                        element={<OrderInvoice />}
                      />
                      <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                      />
                      <Route
                        path={DefaultRoutes.starredOrders}
                        element={<FinancialCoordinatorStarredOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.msdsdirectory}
                        element={<ReadOnlyMSDSFilesListing />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}

          {user.isLogged && user.roles?.includes("PLANNER") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="Planner" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route path="/" element={<PlannerHomePage />} />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.home}
                        element={<PlannerHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.pendingOrders}
                        element={<PlannerPendingOrderListing />}
                      />
                      <Route
                        path={DefaultRoutes.releasedOrders}
                        element={<ReleaseOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.canceledOrders}
                        element={<CanceledOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.allPendingOrders}
                        element={<AllPendingOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.groupView}
                        element={<GroupedOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.allReleasedOrders}
                        element={<AllReleasedOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.clearanceDashboard}
                        element={<ClearanceDashboard />}
                      />
                      <Route
                        path={DefaultRoutes.orderInfo}
                        element={<PlannerOrderInfoPage />}
                      />
                      <Route
                        path={DefaultRoutes.invoice}
                        element={<OrderInvoice />}
                      />
                      <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                      />
                      <Route
                        path={DefaultRoutes.starredOrders}
                        element={<PlannerStarredOrderListing />}
                      />
                      <Route
                        path={DefaultRoutes.msdsdirectory}
                        element={<ReadOnlyMSDSFilesListing />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}

          {user.isLogged && user.roles?.includes("FORM_4") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="Form 4" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route path="/" element={<RolesHomePage />} />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.home}
                        element={<RolesHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.pendingOrders}
                        element={<Form4PendingOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.transactionOrderListing}
                        element={<TreasuryCoordinatorOrderListing />}
                      />
                      <Route
                        path={DefaultRoutes.groupView}
                        element={<GroupedOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.transactionDetails}
                        element={<TreasuryCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.transactionGroupDetails}
                        element={<TreasuryCoordinatorTransactionDetails />}
                      />
                      <Route
                        path={DefaultRoutes.releasedOrders}
                        element={<ReleaseOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.canceledOrders}
                        element={<CanceledOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.clearanceDashboard}
                        element={<ClearanceDashboard />}
                      />
                      <Route
                        path={DefaultRoutes.orderInfo}
                        element={<Form4OrderInfoPage />}
                      />
                      <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                      />
                      <Route
                        path={DefaultRoutes.starredOrders}
                        element={<Form4StarredOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.msdsdirectory}
                        element={<ReadOnlyMSDSFilesListing />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}

          {user.isLogged && user.roles?.includes("QUALITY_MEMBER") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="Quality" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route path="/" element={<QualityHomePage />} />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.home}
                        element={<QualityHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.allReleasedOrders}
                        element={<AllReleasedOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.orderInfo}
                        element={<QualityOrderInfoPage />}
                      />
                      <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}

          {user.isLogged && user.roles?.includes("WAREHOUSE_MEMBER") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="WareHouse" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route path="/" element={<WareHouseHomePage />} />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.home}
                        element={<WareHouseHomePage />}
                      />
                      <Route
                        path={DefaultRoutes.allReleasedOrders}
                        element={<AllReleasedOrdersListing />}
                      />
                      <Route
                        path={DefaultRoutes.orderInfo}
                        element={<WareHouseOrderInfoPage />}
                      />
                      <Route
                        path={DefaultRoutes.notifications}
                        element={<Notification />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}

          {user.isLogged && user.roles?.includes("ADMIN") && (
            <Route
              path="*"
              element={
                <>
                  <NavBarWrapper user={user}>
                    <NavigationBar text="Admin" user={user} />
                  </NavBarWrapper>
                  {user.isLogged && <SideBar />}
                  <Box
                    sx={{
                      pt: `${theme.navbar.navbarHeight}px`,
                      ml: `${theme.sidebar.sidebarWidth}px`,
                    }}
                  >
                    <Routes>
                      <Route path="/" element={<AdminHome />} />
                      <Route
                        path={DefaultRoutes.home}
                        element={<AdminHome />}
                      />
                      <Route
                        path={DefaultRoutes.materials}
                        element={<MaterialsListing />}
                      />
                      <Route
                        path={DefaultRoutes.warehouses}
                        element={<WarhousesListing />}
                      />
                      <Route
                        path={DefaultRoutes.suppliers}
                        element={<SuppliersListing />}
                      />
                      <Route
                        path={DefaultRoutes.storageLocations}
                        element={<StorageLocationsListing />}
                      />
                      <Route
                        path={DefaultRoutes.clearanceAgents}
                        element={<ClearanceAgentsListing />}
                      />
                      <Route
                        path={DefaultRoutes.agentPortfolio}
                        element={<AgentPortfolio />}
                      />
                      <Route
                        path={DefaultRoutes.vendors}
                        element={<VendorsListing />}
                      />
                      <Route
                        path={DefaultRoutes.vendorPortfolio}
                        element={<VendorPortfolio />}
                      />
                      <Route
                        path={DefaultRoutes.categories}
                        element={<CategoriesListing />}
                      />
                      <Route
                        path={DefaultRoutes.banks}
                        element={<BanksListing />}
                      />
                      <Route
                        path={DefaultRoutes.shippingLines}
                        element={<ShippingLinesListing />}
                      />
                      <Route
                        path={DefaultRoutes.users}
                        element={<UsersListing />}
                      />
                      <Route
                        path={DefaultRoutes.planners}
                        element={<PlannersListing />}
                      />
                      <Route
                        path={DefaultRoutes.profile}
                        element={<Profile />}
                      />
                      <Route
                        path={DefaultRoutes.bulkInsert}
                        element={<BulkInsert />}
                      />
                      <Route
                        path={DefaultRoutes.error}
                        element={<FallbackPage isErrorPage={true} />}
                      />
                    </Routes>
                  </Box>
                </>
              }
            />
          )}
        </Routes>
      </>
    </Router>
  );
}
